"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const lodash_1 = require("lodash");
const redux_actions_1 = require("redux-actions");
const transactionsTypes_1 = require("companion-app-components/flux/transactions/transactionsTypes");
const core_actions_1 = require("companion-app-components/flux/core-actions");
const transactions_1 = require("companion-app-components/flux/transactions");
const core_1 = require("companion-app-components/utils/core");
const optimalCacheManager_1 = require("data/optimalCacheManager");
const types_1 = require("./types");
const log = (0, core_1.getLogger)('data/transactions/reducer.js');
let previousState;
const transactionsReducerPre = (0, redux_actions_1.handleActions)({}, (0, types_1.TransactionStore)({ resourceName: 'TRANSACTIONS' }));
// compareFunc that ignores 'modifiedAt' to prevent unnecessary updates and also treats null & undefined as equivalent
const txnCompare = (val1, val2, key) => (key === 'modifiedAt' || (!val1 && !val2) ? true : undefined);
const handleReductions = (state, transactions) => {
    let newState = state;
    // If the UPSERT is more than 10 transactions, then don't optimize, but force selectors to recalculate
    const doOptimize = (transactions === null || transactions === void 0 ? void 0 : transactions.length) <= 10;
    if (doOptimize) {
        // Initialize the reduction using optimalCacheManager
        const upsertId = new Date().valueOf();
        newState = (0, optimalCacheManager_1.initReductions)(newState, upsertId);
        transactions.forEach((transaction) => {
            var _a;
            const oldTransaction = previousState === null || previousState === void 0 ? void 0 : previousState.resourcesById.get(transaction.id || transaction.clientId);
            const newTransaction = transaction.isDeleted
                ? transaction
                : newState.resourcesById.get(transaction.id || transaction.clientId);
            if (!(0, lodash_1.isEqualWith)(oldTransaction === null || oldTransaction === void 0 ? void 0 : oldTransaction.toJS(), (_a = newTransaction === null || newTransaction === void 0 ? void 0 : newTransaction.toJS) === null || _a === void 0 ? void 0 : _a.call(newTransaction), txnCompare)) {
                log.debug('\nnew txn data: SUBMITTING UPSERT');
                newState = (0, optimalCacheManager_1.addReduction)(newState, oldTransaction, newTransaction, upsertId);
            }
            else {
                log.debug('\nequivalent txn: SKIPPING UPSERT');
            }
        });
    }
    else {
        newState = (0, optimalCacheManager_1.clearReductions)(newState);
    }
    return newState;
};
const transactionsReducerPost = (0, redux_actions_1.handleActions)({
    [core_actions_1.coreActions.SANITIZE]: (state) => 
    // TODO: init lastReductions in Record prototype
    state.set('lastReductions', (0, optimalCacheManager_1.initReductions)(state.set('lastReductions', null)).lastReductions),
    [(0, redux_actions_1.combineActions)(transactions_1.transactionsActions.batchTransactions, transactions_1.transactionsActions.batchTransactionsSuccess, transactions_1.transactionsActions.applyTransactionsChanges, transactions_1.transactionsActions.performTransactionActionSuccess).toString()]: (state, action) => handleReductions(state, action.payload),
    [(0, redux_actions_1.combineActions)(transactions_1.transactionsActions.createTransaction, transactions_1.transactionsActions.createTransactionSuccess, transactions_1.transactionsActions.updateTransaction, transactions_1.transactionsActions.updateTransactionSuccess, transactions_1.transactionsActions.deleteTransaction, transactions_1.transactionsActions.deleteTransactionSuccess).toString()]: (state, action) => handleReductions(state, [action.payload]),
    [transactions_1.transactionsActions.getTransactionsSuccess.type]: (state, { payload }) => handleReductions(state, payload.resources),
}, (0, transactionsTypes_1.mkTransactionStore)());
// chain reducers
const reducer = (state, action) => {
    let newState = state;
    previousState = state;
    newState = transactionsReducerPre(newState, action);
    newState = (0, transactions_1.transactionsReducer)(newState, action);
    newState = transactionsReducerPost(newState, action);
    return newState;
};
exports.reducer = reducer;
exports.default = exports.reducer;
